

import {
 
  FETCH_RAWITEMS_REQUEST,
  FETCH_RAWITEMS_SUCCESS,
  FETCH_RAWITEMS_FAILURE,

  CREATE_RAWITEM_REQUEST,
  CREATE_RAWITEM_SUCCESS,
  CREATE_RAWITEM_FAILURE,

  UPDATE_RAWITEM_REQUEST,
  UPDATE_RAWITEM_SUCCESS,
  UPDATE_RAWITEM_FAILURE,

  DELETE_RAWITEM_REQUEST,
  DELETE_RAWITEM_SUCCESS,
  DELETE_RAWITEM_FAILURE,
} from "./rawItemActionTypes";

export const fetchRawItemsRequest = () => ({
  type: FETCH_RAWITEMS_REQUEST,
});

export const fetchRawItemsSuccess = (data, dataType) => ({
  type: FETCH_RAWITEMS_SUCCESS,
  payload: { data, type: dataType },
});

export const fetchRawItemsFailure = (error) => ({
  type: FETCH_RAWITEMS_FAILURE,
  payload: error,
});

export const createRawItemRequest = () => ({
  type: CREATE_RAWITEM_REQUEST,
});

export const createRawItemSuccess = (data, dataType) => ({
  type: CREATE_RAWITEM_SUCCESS,
  payload: { data, type: dataType },
});

export const createRawItemFailure = (error) => ({
  type: CREATE_RAWITEM_FAILURE,
  payload: error,
});

export const updateRawItemRequest = () => ({
  type: UPDATE_RAWITEM_REQUEST,
});

export const updateRawItemSuccess = (data, dataType) => ({
  type: UPDATE_RAWITEM_SUCCESS,
  payload: { data, type: dataType },
});

export const updateRawItemFailure = (error) => ({
  type: UPDATE_RAWITEM_FAILURE,
  payload: error,
});

export const deleteRawItemRequest = () => ({
  type: DELETE_RAWITEM_REQUEST,
});

export const deleteRawItemSuccess = (data, dataType) => ({
  type: DELETE_RAWITEM_SUCCESS,
  payload: { data, type: dataType },
});

export const deleteRawItemFailure = (error) => ({
  type: DELETE_RAWITEM_FAILURE,
  payload: error,
});
